import { Box, Paper, Tab, Tabs, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";

export const tabs = [
  {
    label: "Summary Data",
    link: "summary-data",
  },
  {
    label: "PTO Balances",
    link: "pto-balances",
  },
];

const ReportDetails = () => {
  const [value, setValue] = useState(0);

  const location = useLocation();

  useEffect(() => {
    let i = tabs.findIndex((x) => {
      return location.pathname.includes(x.link);
    });

    setValue(i);
  }, [location]);

  return (
    <Paper className="p-4" sx={{ marginTop: "1rem" }}>
      <Typography variant="h5">Report Details</Typography>

      <Box className="mt-4" sx={{ width: "100%" }}>
        <Tabs value={value} onChange={(event, newValue) => setValue(newValue)}>
          {tabs.map((item, index) => {
            return (
              <Tab
                key={item.link}
                label={item.label}
                component={item.disable ? "div" : Link}
                to={item.disable ? undefined : item.link}
                disabled={item.disable}
                sx={{
                  "&.Mui-selected": {
                    fontWeight: 700,
                  },
                }}
              />
            );
          })}
        </Tabs>
      </Box>
      <Box className="mt-4">
        <Outlet />
      </Box>
    </Paper>
  );
};

export default ReportDetails;
